import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Cart2, XLg } from 'react-bootstrap-icons';
import { useCart } from './ContextReducer';
import Cart from '../screen/Cart';
import Modal from '../Modol';


export default function Header(props) {

    const [CartView, setCartView] = useState(false)
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleButton = () => {
        setIsExpanded(!isExpanded);
    };

    const data = useCart()

    const navigate = useNavigate();


    const handlelogout = () => {
        localStorage.removeItem("authToken");
        navigate("/")
    }

    return (
        <>
            <div className="shadow p-2 mb-1 bg-body rounded fixed-top">
                <nav className="navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <Link className="navbar-brand" to="/">Grocery Store</Link>
                        <button className="navbar-toggler" onClick={toggleButton} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            {isExpanded ? <span><XLg/></span> : <span className="navbar-toggler-icon"></span>}
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                <li className="nav-item">
                                    <Link className="nav-link" aria-current="page" to="/">Home</Link>
                                </li>
                                {(localStorage.getItem("authToken"))
                                    ? <li className="nav-item">
                                        <Link className="nav-link" to="/myoder">My Order</Link>
                                    </li> : ""
                                }
                            </ul>
                            <form className="d-flex search-bar">
                                {props.input}
                                {/* <button className="btn btn-outline-success" type="submit">Search</button> */}
                            </form>
                            {(!localStorage.getItem("authToken"))
                                ?
                                <div className='d-flex'>
                                    <Link className="btn bg-success text-white mx-1 logout-btn" to="/Login">Login</Link>
                                    <Link className="btn bg-success text-white mx-1 logout-btn" to="/register">Signup</Link>
                                </div>
                                : <div className='icons-list'>
                                    <button className='icons-cart' onClick={() => { setCartView(true) }}><Cart2 />
                                        <span className='ml-5 fs-5' style={{ color: "green" }}>{data.length}</span>
                                    </button>
                                    {CartView ? <Modal onClose={() => setCartView(false)}><Cart></Cart></Modal> : ""}
                                    {/* <button className='icons-person'><PersonCircle /></button> */}
                                    
                                    <button className="btn bg-success text-white mb-1 mx-3 logout-btn" onClick={handlelogout}>
                                        Logout
                                    </button>
                                    
                                </div>
                            }

                        </div>
                    </div>
                </nav>
            </div>
        </>
    )
}
